import { isNil } from 'lodash-es';
import { ADVERTISED_PRICE_SOURCE } from 'site-modules/shared/constants/inventory/prices';

export function getDisplayPriceLabel(priceSource) {
  if (isNil(priceSource) || !Object.values(ADVERTISED_PRICE_SOURCE).includes(priceSource)) {
    return '';
  }

  return priceSource === ADVERTISED_PRICE_SOURCE.INTERNET_PRICE ? 'Dealer Price' : 'MSRP';
}
